import ReactOnRails from 'react-on-rails';

import NewsletterForm from './../../layout/components/newsletter/newsletter_form';

import OfferTypeTabs from './components/tabs/index';
import AdvancedSearchForm from './components/advanced_search/index';
import OffersList from './components/offers_list/index';
import LoggedInNotification from './../../layout/components/logged_in_notify';
import OffersSeoWrapper from './components/index';
import OffersPage from './index';
import RegionsPage from './regions';
import HotelsListPage from './hotels_list';
import TvOffers from './tv_offers';

ReactOnRails.register({
  NewsletterForm,
  OfferTypeTabs,
  AdvancedSearchForm,
  OffersList,
  LoggedInNotification,
  OffersSeoWrapper,
  OffersPage,
  RegionsPage,
  HotelsListPage,
  TvOffers
});



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/registration.jsx